declare namespace $ {

	export class $mol_icon_dock_right extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=right.view.tree.d.ts.map